import { createTreeSearchController } from './InsertionSharedCode';

// Export BST search controller (isAVL = false)
export default createTreeSearchController(false);

